import type React from "react";
import type {NodeProps} from "@xyflow/react";
import {Stack, Typography} from "@mui/material";
import {MONO_FONT} from "~/style/fonts";
import type {LaneNode} from "~/pages/supplier-360/tabs/SupplierValueChain/components/chain/valueChainLayout";

/** A column heading inside the canvas (the design's `svc-lane`), so it pans and zooms with its column. */
export const ChainLaneNode: React.FC<NodeProps<LaneNode>> = ({data}) => {
    const {label, align} = data;

    return (
        <Stack justifyContent="center" alignItems={align === 'left' ? 'flex-start' : 'flex-end'} height="100%">
            <Typography noWrap title={label} sx={{font: `600 10.5px ${MONO_FONT}`, color: 'text.secondary'}}>
                {label}
            </Typography>
        </Stack>
    );
};
